import React from 'react';
import { useNavigate } from 'react-router-dom';
import PowerBIEmbed from '../../components/PowerBIEmbed';
import './styles.css';

const RetailPage = () => {
  const navigate = useNavigate();

  return (
    <div className="sector-page">
      <header className="sector-header">
        <h1>Retail Sector</h1>
        <button 
          className="back-to-dashboard-btn"
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      </header>
      <div className="sector-content">
        <div className="sector-iframe-wrapper">
          <PowerBIEmbed />
        </div>
      </div>
    </div>
  );
};

export default RetailPage;


